<template>
  <div class="update-container">
    <div class="info-cell">
      <input
        @blur="upblur"
        @focus="upfocus"
        type="text"
        v-model="userobj.val"
      />
      <van-icon @click="upclean" :class="{ 'up-i-hide': ihide }" name="clear" />
    </div>
    <div class="public-btn" @click.stop="submit">
      <span>保存</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "update",
  data() {
    return {
      ihide: true,
      userobj:this.$route.params.data,
      clicked: false
    };
  },
  mounted() {
  },
  methods: {
    submit() {
      if (this.clicked) {
        return;
      }
      const that = this
      //reg = /^[A-Za-z0-9\u4e00-\u9fa5\.·]{1,10}$/;
      let reg = /^1[34578]\d{9}$/;
      if (this.userobj.val.length > 0) {
        if (this.userobj.val == "qc0000") {
          localStorage.clear();
          that.$router.push("information");
          return;
        }
        let upmsuser = this.$storage.get("upmsUser");
        let _user = {};
        switch (this.userobj.key) {
          case "nick_name":
            _user = {
              id: upmsuser.id,
              nickName: this.userobj.val
            };
            break;
          case "account_id":
            if (!reg.test(this.userobj.val)) {
              this.$toast(this.userobj.txt + "格式错误");
              return;
            }
            _user = {
              accountId: this.userobj.val,
              id: upmsuser.id
            };
            break;
          case "unit":
            _user = {
              id: upmsuser.id,
              unit: this.userobj.val
            };
            break;
        }
        this.clicked = true;
        that
          .$http({
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            },
            method: "post",
            url: that.$initUrl.api_url + "/xjjc_user",
            data: JSON.stringify(_user)
          })
          .then(r => {
            that.clicked = false;
            that.$notify({ type: "success", message: "保存成功" });
            that.$storage.remove("sso");
            that.$router.push("information");
            console.log("保存成功:", r);
          })
          .catch(e => {
            that.clicked = false;
            that.$notify({ type: "danger", message: "保存失败" });
            console.log("保存失败:", e);
          });
      } else {
        this.$notify({
          type: "danger",
          message: this.userobj.txt + "不能为空"
        });
      }
    },
    upblur() {
      let that = this;
      setTimeout(function() {
        that.ihide = true;
      }, 100);
    },
    upfocus() {
      if (this.userobj.val) {
        this.ihide = false;
      }
    },
    upclean() {
      this.userobj.val = "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
.update-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  .info-cell{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    height: px2rem(50);
    width: 95%;
    margin-top: px2rem(43);
    border-radius: 6px;
    background-image: linear-gradient(162deg, rgb(45,51,57), rgb(36,40,45));
    text-stroke:2px linear-gradient(157deg, rgb(78,78,78), rgb(34,38,43));
    box-shadow:inset 0px 2px 2px rgba(0,0,0,0.21);
    input{
      background-color: rgba(0,0,0,0);
      border: 0;
      color: #ffffff;
      font-size: px2rem(16);
    }
  }
}
</style>
